import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import DraperyComponent from '../components/products/Draperysection';
import Footer from '../components/Footer';
import api from '../axios/axios';

import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useClerk } from '@clerk/clerk-react'; // Import useClerk from Clerk
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/product/productSlice';
import { setCart } from '../redux/features/auth/userSlice';
import CartDetails from '../components/cart/CartDetail';
import Spinner from '../utils/Spinner';

const Cart = () => {
  const { isSignedIn } = useClerk(); // Destructure isSignedIn from useClerk
    const loading = useSelector((state) => state.product.loading);
  
  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize navigate
  useEffect(() => {
   
      if(currentUser){
      fetchCart();
      }
    
  }, [currentUser, navigate]); // Dependency on isSignedIn and navigate

  const fetchCart = async () => {
    try {
      dispatch(setLoading(true)); // Start loading state
      const response = await api.get('user/getCart/', {
        params: {
          userId: currentUser?._id,
        },
      });
      dispatch(setCart(response.data.cart)); // Set cart in the Redux store
      dispatch(setLoading(false)); // End loading state
    } catch (error) {
      dispatch(setLoading(false)); // End loading state in case of error
      Swal.fire("Something went wrong")
    }
  };
  if (loading) {
    return <><Spinner/></>;
  } 

  return (
    <>
      <div><Navbar /></div>
      <div><CartDetails fetchCart={fetchCart} /></div>
      <div><DraperyComponent /></div>
      <div><Footer /></div>
    </>
  );
};

export default Cart; 